import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const uniformDepreciationList = createAsyncThunk(
  'uniform-depreciation-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-uniform-depreciation/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeUniformDepreciation = createAsyncThunk(
  'uniform-depreciation-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-uniform-depreciation/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const getUniformDepreciationById = createAsyncThunk(
  'uniform-depreciation-get',
  async (id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-uniform-depreciation/edit/` + id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const uniformDepreciationReport = createAsyncThunk(
  'uniform-depreciation-report',
  async (params: any, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-uniform-depreciation/report`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const printUniformDepreciationReport = createAsyncThunk(
  'print-uniform-depreciation-report',
  async (params: any, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-uniform-depreciation/report-print`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getSchoolExistsUniformList = createAsyncThunk(
  'school-exists-uniform-list',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-uniform-depreciation/get_exists_uniform_stock`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const UniformStock = createAsyncThunk(
  'Uniform-stock',
  async ({clsId, stdId}: {clsId: any; stdId: any}, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}school-uniform-depreciation/uniform-stock/${clsId}/${stdId}`
      )
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type DepreciationState = {
  errors: any
}

const initialState: DepreciationState = {
  errors: '',
}

export const uniformDepreciationSlice = createSlice({
  name: 'item-depreciation',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeUniformDepreciation.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = uniformDepreciationSlice.actions
export default uniformDepreciationSlice.reducer
